<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useState } from '~renderer/composables/useState'

  const { DEV } = import.meta.env
  const { adsEnabled } = useState()

  onMounted(() => {
    window.nitroAds.createAd('island-card-ad', {
      demo: DEV,
      sizes: [[300, 250]],
      refreshTime: 60,
      report: {
        enabled: true,
        wording: 'Report Ad',
        position: 'bottom-right',
      },
    })
  })
</script>

<template>
  <div id="island-card-ad" v-if="adsEnabled"></div>
</template>
